'use client';
import { useCallback, useEffect, useState, useRef } from 'react';
import Script from "next/script";

// Component
import Ask from '@MODAL/Ask';
import Header from './_layouts/header';
// import ServiceTab from './_components/_kob/ServiceTab';
// import CustomerSup from './_components/CustomerSup';

// Script
// import Main from '@JS/main';
// import OfflinePayment from './_components/OfflinePay';
// import Payservice from './_components/Payservice';

export default function Home({ htmlString }) {
  const [mounted, setMounted] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
      if (typeof window !== 'undefined') {
          const script = document.createElement('script');
          script.src = '/js/common.js';
          script.async = false;
          document.body.appendChild(script);

          const jquery = document.createElement('script');
          jquery.src = '/js/lib/jquery-3.7.1.min.js';
          jquery.async = false;
          document.head.appendChild(jquery);

          const validate = document.createElement('script');
          validate.src = '/js/lib/jquery.validate.min.js';
          validate.async = false;
          document.head.appendChild(validate);

          const aos = document.createElement('script');
          aos.src = '/js/lib/aos.min.js';
          aos.async = false;
          document.head.appendChild(aos);

          const swiper = document.createElement('script');
          swiper.src = '/js/lib/swiper-bundle-11.0.6.min.js';
          swiper.async = false;
          document.head.appendChild(swiper);

          const selectric = document.createElement('script');
          selectric.src = '/js/lib/selectric-1.13.0.min.js';
          selectric.async = false;
          document.head.appendChild(selectric);

          const countup = document.createElement('script');
          countup.src = '/js/lib/countup.min.js';
          countup.async = false;
          document.head.appendChild(countup);

          if (window.initCountUp) {
            window.initCountUp();
          }
      }
      setMounted(true)
  }, []);

  useEffect(() => {
    if (!containerRef.current) return;
    
    const targetEl = containerRef.current.querySelector('[data-count-target]');
    
    if (targetEl) {
      window.initCountUp();
    }

  }, [htmlString]);


  return (
    <>
        <main ref={containerRef}>
            <div dangerouslySetInnerHTML={{
                __html: mounted && `
                    
                    <div class="contents">
                        <section class="main_visual">
                            <span class="radius bottom">
                                <a href="upload/회사소개서.pptx" download="아이원페이먼트_회사소개서.pptx">회사소개서</a>
                            </span>
                            <div class="swiper-wrapper">
                                <div class="swiper-slide">
                                    <a href="javascript:void(0)">
                                        <figure>
                                            <img src="/img/main_visual_01.webp" alt="main_visual_01"/>
                                            <figcaption class="text_wrap">
                                                <h2>가맹 사업에 필요한<br/>카드결제 &amp; 전산시스템<br/>서비스의 모든 것</h2>
                                                <p>당신의 성공 파트너, 아이원페이먼트와 함께<br/>성공적인 비즈니스를 시작해보세요!</p>
                                            </figcaption>
                                        </figure>
                                    </a>
                                </div>
                                <div class="swiper-slide">
                                    <a href="javascript:void(0)">
                                        <figure>
                                            <img src="/img/main_visual_02.webp" alt="main_visual_02"/>
                                            <figcaption class="text_wrap">
                                                <h2>사업 모델에 최적화된<br/>통합관리 경험 제공</h2>
                                                <p>아이원페이먼트의 직관적인 관리자 페이지로<br/>결제 및 통합정산 관리가 더욱 간편해집니다.</p>
                                            </figcaption>
                                        </figure>
                                    </a>
                                </div>
                                <div class="swiper-slide">
                                    <a href="javascript:void(0)">
                                        <figure>
                                            <img src="/img/main_visual_03.webp" alt="main_visual_03"/>
                                            <figcaption class="text_wrap">
                                                <ul class="app_icon">
                                                    <li>
                                                        <img src="/img/logo/logo_alipay.svg" alt="알리페이"/>
                                                    </li>
                                                    <li>
                                                        <img src="/img/logo/logo_wechatpay.svg" alt="위챗페이"/>
                                                    </li>
                                                </ul>
                                                <h2>글로벌 간편 결제<br/>알리 · 위챗페이 연동</h2>
                                                <p>글로벌 결제 서비스 도입을 통한 해외 관광객 유치,<br/>매출 증대, 고객 만족도 향상에 기여하겠습니다.</p>
                                            </figcaption>
                                        </figure>
                                    </a>
                                </div>
                            </div>
                            <div class="swiper-controller">
                                <div class="pagination_wrap">
                                    <div class="swiper-button-prev"></div>
                                    <div class="swiper-pagination"></div>
                                    <div class="autoplay-progress">
                                        <svg viewBox="0 0 100 10">
                                            <line x1="0" y1="0" x2="100" y2="0"/>
                                        </icon>
                                    </div>
                                    <div class="swiper-play-state">
                                        <div class="slide-pause"></div>
                                        <div class="slide-play"></div>
                                    </div>
                                    <div class="swiper-button-next"></div>
                                </div>
                            </div>
                            <!-- <p class="scroll_down">scroll</p> -->
                        </section>
                        <section class="main_partners">
                            <div class="inner_wrap">
                                <div class="text_wrap">
                                    <h3><em>파트너사</em>우리의 든든한 파트너를 소개합니다.</h3>
                                    <p>끊임 없는 협력과 최고를 향한 집념으로 공동의 목표를 달성하고 더 나은 가능성을 열어가겠습니다.</p>
                                </div>
                                <ul>
                                    <li>
                                        <span class="radius left">
                                            <em>PG 결제 서비스</em>
                                        </span>
                                        <figure>
                                            <figcaption>
                                                <h4>이지피쥐</h4>
                                                <p>금융감독원 정식 라이센스<br/>PG / 간편결제 / VAN 제공</p>
                                            </figcaption>
                                            <img src="/img/logo/logo_ezpg.svg" alt="이지피쥐 로고"/>
                                        </figure>
                                        <span class="radius link blank bottom">
                                            <a href="http://www.ez-pg.net/" target="_blank"></a>
                                        </span>
                                    </li>
                                    <li>
                                        <span class="radius left">
                                            <em>결제 솔루션</em>
                                        </span>
                                        <figure>
                                            <figcaption>
                                                <h4>킹오더브라더스</h4>
                                                <p>누적 가맹점 35,000개<br/>다양한 결제 솔루션 제공</p>
                                            </figcaption>
                                            <img src="/img/logo/logo_kingOrder.svg" alt="킹오더 로고"/>
                                        </figure>
                                        <span class="radius link blank bottom">
                                            <a href="http://www.xn--9m1bt07agwh.com/main" target="_blank" target="_blank"></a>
                                        </span>
                                    </li>
                                    <li>
                                        <span class="radius left">
                                            <em>키오스크 제조/유통</em>
                                        </span>
                                        <figure>
                                            <figcaption>
                                                <h4>매장친구</h4>
                                                <p>국내 최대규모 키오스크 /<br/>테이블 오더 제조 및 유통</p>
                                            </figcaption>
                                            <img src="/img/logo/logo_storeFriend.svg" alt="매장친구 로고"/>
                                        </figure>
                                        <span class="radius link blank bottom">
                                            <a href="javascript:void(0)"></a>
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </section>
                        <section class="main_brands">
                            <div class="inner_wrap small full">
                                <div class="text_wrap">
                                    <h3 class="large"><em>고객사</em>함께하는 브랜드/가맹점</h3>
                                    <p>오프라인 결제 시장을 디지털화하고 차별화된 서비스로 관리의 효율성을 높일 수 있습니다.</p>
                                </div>
                                <div class="loop_wrap">
                                    <div class="title_wrap">
                                        <h4>프렌차이즈</h4>
                                        <div class="util">
                                            <button type="button" class="play"></button>
                                        </div>
                                    </div>
                                    <div class="loop">
                                        <ul>
                                            <li>
                                                <figure>
                                                    <div class="thumb">
                                                        <img src="/img/brand_01.webp" alt="교촌치킨"/>
                                                    </div>
                                                    <figcaption>교촌치킨</figcaption>
                                                </figure>
                                            </li>
                                            <li>
                                                <figure>
                                                    <div class="thumb">
                                                        <img src="/img/brand_02.webp" alt="푸라닭치킨"/>
                                                    </div>
                                                    <figcaption>푸라닭치킨</figcaption>
                                                </figure>
                                            </li>
                                            <li>
                                                <figure>
                                                    <div class="thumb">
                                                        <img src="/img/brand_03.webp" alt="명랑핫도그"/>
                                                    </div>
                                                    <figcaption>명랑핫도그</figcaption>
                                                </figure>
                                            </li>
                                            <li>
                                                <figure>
                                                    <div class="thumb">
                                                        <img src="/img/brand_04.webp" alt="피자알볼로"/>
                                                    </div>
                                                    <figcaption>피자알볼로</figcaption>
                                                </figure>
                                            </li>
                                            <li>
                                                <figure>
                                                    <div class="thumb">
                                                        <img src="/img/brand_05.webp" alt="처갓집양념치킨"/>
                                                    </div>
                                                    <figcaption>처갓집양념치킨</figcaption>
                                                </figure>
                                            </li>
                                            <li>
                                                <figure>
                                                    <div class="thumb">
                                                        <img src="/img/brand_06.webp" alt="포케올데이"/>
                                                    </div>
                                                    <figcaption>포케올데이</figcaption>
                                                </figure>
                                            </li>
                                            <li>
                                                <figure>
                                                    <div class="thumb">
                                                        <img src="/img/brand_07.webp" alt="스텔라떡볶이"/>
                                                    </div>
                                                    <figcaption>스텔라떡볶이</figcaption>
                                                </figure>
                                            </li>
                                            <li>
                                                <figure>
                                                    <div class="thumb">
                                                        <img src="/img/brand_08.webp" alt="60계치킨"/>
                                                    </div>
                                                    <figcaption>60계치킨</figcaption>
                                                </figure>
                                            </li>
                                            <li>
                                                <figure>
                                                    <div class="thumb">
                                                        <img src="/img/brand_09.webp" alt="두찜"/>
                                                    </div>
                                                    <figcaption>두찜</figcaption>
                                                </figure>
                                            </li>
                                            <li>
                                                <figure>
                                                    <div class="thumb">
                                                        <img src="/img/brand_10.webp" alt="걸작떡볶이치킨"/>
                                                    </div>
                                                    <figcaption>걸작떡볶이치킨</figcaption>
                                                </figure>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="loop">
                                        <ul>
                                            <li>
                                                <figure>
                                                    <div class="thumb">
                                                        <img src="/img/brand_11.webp" alt="UFO버거"/>
                                                    </div>
                                                    <figcaption>UFO버거</figcaption>
                                                </figure>
                                            </li>
                                            <li>
                                                <figure>
                                                    <div class="thumb">
                                                        <img src="/img/brand_12.webp" alt="1992덮밥&짜글이"/>
                                                    </div>
                                                    <figcaption>1992덮밥&amp;짜글이</figcaption>
                                                </figure>
                                            </li>
                                            <li>
                                                <figure>
                                                    <div class="thumb">
                                                        <img src="/img/brand_13.webp" alt="33떡볶이&꼬마김밥"/>
                                                    </div>
                                                    <figcaption>33떡볶이&amp;꼬마김밥</figcaption>
                                                </figure>
                                            </li>
                                            <li>
                                                <figure>
                                                    <div class="thumb">
                                                        <img src="/img/brand_14.webp" alt="기대만족"/>
                                                    </div>
                                                    <figcaption>기대만족</figcaption>
                                                </figure>
                                            </li>
                                            <li>
                                                <figure>
                                                    <div class="thumb">
                                                        <img src="/img/brand_15.webp" alt="스쿨푸드"/>
                                                    </div>
                                                    <figcaption>스쿨푸드</figcaption>
                                                </figure>
                                            </li>
                                            <li>
                                                <figure>
                                                    <div class="thumb">
                                                        <img src="/img/brand_16.webp" alt="더맨타코"/>
                                                    </div>
                                                    <figcaption>더맨타코</figcaption>
                                                </figure>
                                            </li>
                                            <li>
                                                <figure>
                                                    <div class="thumb">
                                                        <img src="/img/brand_17.webp" alt="화락바베큐치킨"/>
                                                    </div>
                                                    <figcaption>화락바베큐치킨</figcaption>
                                                </figure>
                                            </li>
                                            <li>
                                                <figure>
                                                    <div class="thumb">
                                                        <img src="/img/brand_18.webp" alt="봉구가래떡볶이"/>
                                                    </div>
                                                    <figcaption>봉구가래떡볶이</figcaption>
                                                </figure>
                                            </li>
                                            <li>
                                                <figure>
                                                    <div class="thumb">
                                                        <img src="/img/brand_19.webp" alt="히노아지"/>
                                                    </div>
                                                    <figcaption>히노아지</figcaption>
                                                </figure>
                                            </li>
                                            <li>
                                                <figure>
                                                    <div class="thumb">
                                                        <img src="/img/brand_20.webp" alt="해남짬뽕"/>
                                                    </div>
                                                    <figcaption>해남짬뽕</figcaption>
                                                </figure>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="loop_wrap">
                                    <div class="title_wrap">
                                        <h4>의료 / 성형외과</h4>
                                        <div class="util">
                                            <button type="button" class="play"></button>
                                        </div>
                                    </div>
                                    <div class="loop reverse">
                                        <ul>
                                            <li>
                                                <figure>
                                                    <div class="thumb">
                                                        <img src="/img/brand_21.webp" alt="하남스타의원"/>
                                                    </div>
                                                    <figcaption>하남스타의원</figcaption>
                                                </figure>
                                            </li>
                                            <li>
                                                <figure>
                                                    <div class="thumb">
                                                        <img src="/img/brand_22.webp" alt="에르샤몽의원"/>
                                                    </div>
                                                    <figcaption>에르샤몽의원</figcaption>
                                                </figure>
                                            </li>
                                            <li>
                                                <figure>
                                                    <div class="thumb">
                                                        <img src="/img/brand_23.webp" alt="봉봉성형외과"/>
                                                    </div>
                                                    <figcaption>봉봉성형외과</figcaption>
                                                </figure>
                                            </li>
                                            <li>
                                                <figure>
                                                    <div class="thumb">
                                                        <img src="/img/brand_24.webp" alt="이편한68플란트치과"/>
                                                    </div>
                                                    <figcaption>이편한68플란트치과</figcaption>
                                                </figure>
                                            </li>
                                            <li>
                                                <figure>
                                                    <div class="thumb">
                                                        <img src="/img/brand_25.webp" alt="디테성형외과"/>
                                                    </div>
                                                    <figcaption>디테성형외과</figcaption>
                                                </figure>
                                            </li>
                                            <li>
                                                <figure>
                                                    <div class="thumb">
                                                        <img src="/img/brand_26.webp" alt="비바덤의원"/>
                                                    </div>
                                                    <figcaption>비바덤의원</figcaption>
                                                </figure>
                                            </li>
                                            <li>
                                                <figure>
                                                    <div class="thumb">
                                                        <img src="/img/brand_27.webp" alt="맥스웰피부과의원"/>
                                                    </div>
                                                    <figcaption>맥스웰피부과의원</figcaption>
                                                </figure>
                                            </li>
                                            <li>
                                                <figure>
                                                    <div class="thumb">
                                                        <img src="/img/brand_28.webp" alt="미소드림치과의원"/>
                                                    </div>
                                                    <figcaption>미소드림치과의원</figcaption>
                                                </figure>
                                            </li>
                                            <li>
                                                <figure>
                                                    <div class="thumb">
                                                        <img src="/img/brand_29.webp" alt="와이퀸산부인과"/>
                                                    </div>
                                                    <figcaption>와이퀸산부인과</figcaption>
                                                </figure>
                                            </li>
                                            <li>
                                                <figure>
                                                    <div class="thumb">
                                                        <img src="/img/brand_30.webp" alt="플란치과의원"/>
                                                    </div>
                                                    <figcaption>플란치과의원</figcaption>
                                                </figure>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="loop reverse">
                                        <ul>
                                            <li>
                                                <figure>
                                                    <div class="thumb">
                                                        <img src="/img/brand_31.webp" alt="상류치과"/>
                                                    </div>
                                                    <figcaption>상류치과</figcaption>
                                                </figure>
                                            </li>
                                            <li>
                                                <figure>
                                                    <div class="thumb">
                                                        <img src="/img/brand_32.webp" alt="다나라의원·한의원"/>
                                                    </div>
                                                    <figcaption>다나라의원·한의원</figcaption>
                                                </figure>
                                            </li>
                                            <li>
                                                <figure>
                                                    <div class="thumb">
                                                        <img src="/img/brand_33.webp" alt="메가비뇨의학과"/>
                                                    </div>
                                                    <figcaption>메가비뇨의학과</figcaption>
                                                </figure>
                                            </li>
                                            <li>
                                                <figure>
                                                    <div class="thumb">
                                                        <img src="/img/brand_34.webp" alt="청담유성형외과센터"/>
                                                    </div>
                                                    <figcaption>청담유성형외과센터</figcaption>
                                                </figure>
                                            </li>
                                            <li>
                                                <figure>
                                                    <div class="thumb">
                                                        <img src="/img/brand_35.webp" alt="연세국민건강내과"/>
                                                    </div>
                                                    <figcaption>연세국민건강내과</figcaption>
                                                </figure>
                                            </li>
                                            <li>
                                                <figure>
                                                    <div class="thumb">
                                                        <img src="/img/brand_36.webp" alt="인스타성형외과"/>
                                                    </div>
                                                    <figcaption>인스타성형외과</figcaption>
                                                </figure>
                                            </li>
                                            <li>
                                                <figure>
                                                    <div class="thumb">
                                                        <img src="/img/brand_37.webp" alt="리앤델클리닉"/>
                                                    </div>
                                                    <figcaption>리앤델클리닉</figcaption>
                                                </figure>
                                            </li>
                                            <li>
                                                <figure>
                                                    <div class="thumb">
                                                        <img src="/img/brand_38.webp" alt="이에스청담성형외과"/>
                                                    </div>
                                                    <figcaption>이에스청담성형외과</figcaption>
                                                </figure>
                                            </li>
                                            <li>
                                                <figure>
                                                    <div class="thumb">
                                                        <img src="/img/brand_39.webp" alt="다나은통증의학과"/>
                                                    </div>
                                                    <figcaption>다나은통증의학과</figcaption>
                                                </figure>
                                            </li>
                                            <li>
                                                <figure>
                                                    <div class="thumb">
                                                        <img src="/img/brand_40.webp" alt="더플러스성형외과"/>
                                                    </div>
                                                    <figcaption>더플러스성형외과</figcaption>
                                                </figure>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section class="main_success">
                            <div class="inner_wrap">
                                <div class="text_wrap">
                                    <h3 class="large">숫자로 보는<br/>아이원페이먼트</h3>
                                    <p><strong>고객의 성공과 함께 성장하겠습니다.</strong>고객의 삶과 비즈니스가 건강한 성장을 이룰 수 있도록 맞춤 서비스와 앞선 전문성으로 차별화된 솔루션을 제안하고 고객의 입장에서 새로운 방향을 제시하며 함께 성장해나가는 기업, 우리는 아이원페이먼트입니다.</p>
                                </div>
                                <ul class="stat_large">
                                    <li>
                                        <strong>
                                            <em class="countup_num" data-count-target="30000" aria-valuenow="0" data-count-delay="300" data-count-speed="2" data-decimals="0">0</em>
                                            <span class="plus">개</span>
                                        </strong>
                                        <p>누적 3만여 개 가맹점에<br/>맞춤 솔루션 공급</p>
                                    </li>
                                    <li>
                                        <strong>
                                            <em class="countup_num" data-count-target="2000" aria-valuenow="0" data-count-delay="300" data-count-speed="2" data-decimals="0">0</em>
                                            <span class="plus">만 명</span>
                                        </strong>
                                        <p>월평균 이용자 2천만 명,<br/>꾸준한 시장 점유율 확대</p>
                                    </li>
                                </ul>
                                <ul class="stat_small">
                                    <li>
                                        <strong>
                                            <em class="countup_num" data-count-target="4.9" aria-valuenow="0" data-count-delay="300" data-count-speed="2" data-decimals="1">0</em>
                                            <span>/ 5점</span>
                                        </strong>
                                        <p>고객 만족도</p>
                                    </li>
                                    <li>
                                        <strong>
                                            <em class="countup_num" data-count-target="4" aria-valuenow="0" data-count-delay="300" data-count-speed="2" data-decimals="0">0</em>
                                            <span class="plus">억 명</span>
                                        </strong>
                                        <p>누적 이용자수</p>
                                    </li>
                                    <li>
                                        <strong>
                                            <em class="countup_num" data-count-target="5" aria-valuenow="0" data-count-delay="300" data-count-speed="2" data-decimals="0">0</em>
                                            <span class="plus">조 원</span>
                                        </strong>
                                        <p>누적 결제 처리금액</p>
                                    </li>
                                    <li>
                                        <strong>
                                            <em class="countup_num" data-count-target="10" aria-valuenow="0" data-count-delay="300" data-count-speed="2" data-decimals="0">0</em>
                                            <span class="plus">만 대</span>
                                        </strong>
                                        <p>누적 설치대수</p>
                                    </li>
                                </ul>
                            </div>
                        </section>
                        <section class="main_factory" id="main_factory">
                            <div class="inner_wrap small">
                                <div class="text_wrap">
                                    <h3 class="large"><em>끊임없는 도전</em>혁신적 기술력과 노하우,<br/>완벽한 품질로 고객에게 다가가겠습니다.</h3>
                                </div>
                                <div class="video_wrap">
                                    <span class="radius large left">
                                        <em>국내 최대 생산시설</em>
                                    </span>
                                    <figure>
                                        <iframe src="https://player.vimeo.com/video/1076864049?quality=1080p&mute=1&autoplay=1&loop=1&title=0&autopause=0&background=1" width="1550" height="610" allow="autoplay; fullscreen; picture-in-picture" frameborder="0"></iframe>
                                        <figcaption>
                                            <strong>Solution &<br/>Service</strong>
                                            <p>효율적인 매장 운영의 필수 아이템,<br/>키오스크와 테이블오더를 생산합니다.</p>
                                        </figcaption>
                                    </figure>
                                </div>
                                <ul>
                                    <li>
                                        <figure>
                                            <img src="/img/icon/icon_c_ticket.svg" alt="할인 아이콘"/>
                                        </figure>
                                        <p><strong>국내 최저가 공급</strong>키오스크와 테이블오더의 국내 최저가에 도전하겠습니다.</p>
                                    </li>
                                    <li>
                                        <figure>
                                            <img src="/img/icon/icon_c_building.svg" alt="공장 아이콘"/>
                                        </figure>
                                        <p><strong>업계 유일 제품 생산시설</strong>국내 최대 규모 생산시설을 갖추어서 퀄리티있는 제품으로 납품하겠습니다.</p>
                                    </li>
                                    <li>
                                        <figure>
                                            <img src="/img/icon/icon_c_relationship.svg" alt="서비스 아이콘"/>
                                        </figure>
                                        <p><strong>제품 하자 시 1년간 무상 교환</strong>매장에서 사용 중 문제 발생 시 책임 회피를 하지 않겠습니다.</p>
                                    </li>
                                </ul>
                            </div>
                        </section>
                        <section class="main_venture">
                            <div class="inner_wrap">
                                <div class="text_wrap">
                                    <h3><em>벤처기업</em>
                                        벤처기업 인증을 통한 신뢰와 기술력으로 안전한 결제를 제공합니다
                                    </h3>
                                    <!-- <p>끊임 없는 협력과 최고를 향한 집념으로 공동의 목표를 달성하고 더 나은 가능성을 열어가겠습니다.</p> -->
                                </div>
                                <div style="display:flex; justify-content:center;">
                                    <img src="/img/venture/venture.jpg" />
                                </div>
                            </div>
                        </section>
                        <section class="main_venture">
                            <div class="inner_wrap">
                                <div class="text_wrap">
                                    <h3><em>특허기업</em>
                                        차별화된 기술력과 혁신으로 우수한 서비스를 제공합니다
                                    </h3>
                                </div>
                                <div style="display:flex; justify-content:center;">
                                    <img src="/img/venture/patent.jpg" />
                                </div>
                                <br />
                                <div style="display:flex; justify-content:center;">
                                  <img src="/img/venture/ai.jpg" />
                                </div>
                            </div>
                        </section>
                    </div>
                    
                    <script type="text/javascript">
                        $(function() {
                            // $('.main_menu > li:nth-child(1)').addClass('active current');
                            // initCountUp();
                        });
                    </script>
                `
            }}>
            </div>
        </main>
    </>
  )
}